var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircleIcon = function SvgHelpCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.286 8.277v-.001a.833.833 0 0 1-1.576-.54L7.5 8l-.79-.265v-.003l.003-.005.003-.011a2 2 0 0 1 .047-.117c.03-.069.072-.16.131-.265.117-.21.301-.484.575-.758.565-.562 1.47-1.076 2.82-1.076 1.475 0 2.67.936 2.972 2.243.311 1.344-.37 2.783-1.988 3.75l-.027.017-.029.014c-.102.051-.653.474-.653 1.476a.833.833 0 0 1-1.667 0c0-1.635.903-2.614 1.543-2.95 1.15-.696 1.303-1.473 1.197-1.931-.116-.5-.594-.952-1.349-.952-.88 0-1.37.319-1.642.59a1.8 1.8 0 0 0-.352.5l-.008.019q0 .003 0 0M10 16.334a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.833 10.5a9.167 9.167 0 1 1 18.334 0 9.167 9.167 0 0 1-18.334 0M10 3a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15",
    clipRule: "evenodd"
  })));
};
export default SvgHelpCircleIcon;